import ShippingAddressIcon from "icons/ShippingAddressIcon";
import { FC, useEffect, useState } from "react";
import { useAddShippingAddress } from "services/address";
import { IShippingAddress } from "types/address";
import { getFullAddress } from "utils/address";
import AddUserAddressModal from "./AddUserAddressModal";
import SelectUserAddressModal from "./SelectUserAddressModal";
import { Plus } from "lucide-react";

interface IAddressCard {
  data: IShippingAddress[];
  onChange: (value: number) => void;
}
const AddressCard: FC<IAddressCard> = ({ data, onChange }) => {
  const [isModalAddressOpen, setIsModalAddressOpen] = useState<boolean>(false);
  const [isModalSelectAddressOpen, setIsModalSelectAddressOpen] =
    useState<boolean>(false);

  const [selectedAddress, setSelectedAddress] = useState<IShippingAddress>(
    data[0]
  );

  const { addShippingAddressAsync, isPending } = useAddShippingAddress();

  const showModalAddress = () => {
    setIsModalAddressOpen(true);
  };

  const handleModalAddressOk = async (value: IShippingAddress) => {
    await addShippingAddressAsync(value);
    setIsModalAddressOpen(false);
  };

  const handleModalAddressCancel = () => {
    setIsModalAddressOpen(false);
  };

  const showModalSelectAddress = () => {
    setIsModalSelectAddressOpen(true);
  };

  const handleModalSelectAddressOk = async (value: number) => {
    onChange(value);
    setIsModalSelectAddressOpen(false);
  };

  const handleModalSelectAddressCancel = () => {
    setIsModalSelectAddressOpen(false);
  };

  const handleOnSelectAddress = (value: number) => {
    const newAddress = data.find((address) => address.id === value);
    if (newAddress) {
      setSelectedAddress(newAddress);
    }
  };

  useEffect(() => {
    if (data && data.length !== 0) {
      const defaultAddress = data.find((address) => address.isDefault);
      if (defaultAddress) {
        setSelectedAddress(defaultAddress);
      }
    }
  }, [data]);

  if (!data || data.length === 0 || !selectedAddress) {
    return (
      <>
        <div className="bg-[#F8F8F8] p-4 my-4 h-[144px]">
          <div>
            ที่อยู่จัดส่ง:{" "}
            <span className="text-[#ACA7A7]">ยังไม่มีข้อมูล</span>
          </div>
          <div
            className="pl-8 mt-4 text-center flex justify-center cursor-pointer gap-1"
            onClick={showModalAddress}
          >
            <Plus />
            <div className="underline">เพิ่มที่อยู่</div>
          </div>
        </div>
        <AddUserAddressModal
          open={isModalAddressOpen}
          onOk={handleModalAddressOk}
          onCancel={handleModalAddressCancel}
          isLoading={isPending}
        />
      </>
    );
  }

  return (
    <>
      <div className="bg-[#F8F8F8] p-4 my-4">
        <div className="flex justify-between">
          <div>ที่อยู่จัดส่ง:</div>
          <div
            className="underline flex items-center gap-2 cursor-pointer"
            onClick={showModalSelectAddress}
          >
            <ShippingAddressIcon />
            เลือกที่อยู่ในการจัดส่ง
          </div>
        </div>
        <div className="pl-8 mt-4">
          <div>ชื่อผู้ส่ง: {selectedAddress.fullName}</div>
          <div>
            ที่อยู่ :{" "}
            {getFullAddress({
              building: selectedAddress.building,
              moo: selectedAddress.moo,
              road: selectedAddress.road,
              address: selectedAddress.address,
              district: selectedAddress.district,
              postCode: selectedAddress.postCode,
              province: selectedAddress.province,
              subdistrict: selectedAddress.subdistrict,
            })}
          </div>
          <div>โทร: {selectedAddress.phoneNumber}</div>
        </div>
      </div>
      <SelectUserAddressModal
        open={isModalSelectAddressOpen}
        onOk={handleModalSelectAddressOk}
        onCancel={handleModalSelectAddressCancel}
        isLoading={isPending}
        addressList={data}
        selectedAddressId={selectedAddress.id}
        onSelectAddress={handleOnSelectAddress}
      />
    </>
  );
};
export default AddressCard;
